<!--本人確認書類申請-->
<template>
  <div class="i0002">
    <div class="i0002-title">
      <!-- 本人確認書類の利用目的 -->
      <p>{{$t('MODULE.I0002_LBL_TITLE')}}</p>
    </div>
    <div class="i0002-main">
      <ul>
        <li>
          <!-- 給与所得・退職所得の源泉徴収票作成事務 -->
          {{$t('MODULE.I0002_LBL_TEXT1')}}
        </li>
        <li>
          <!-- 給与所得者の扶養控除等(異動)申告書作成事務 -->
          {{$t('MODULE.I0002_LBL_TEXT2')}}
        </li>
        <li>
          <!-- 給与所得者の保険料控除申告書作成事務 -->
          {{$t('MODULE.I0002_LBL_TEXT3')}}
        </li>
        <li>
          <!-- 給与所得者の配偶者特別控除申告書作成事務 -->
          {{$t('MODULE.I0002_LBL_TEXT4')}}
        </li>
        <li>
          <!-- 地方税に関する事務 -->
          {{$t('MODULE.I0002_LBL_TEXT5')}}
        </li>
        <li>
          <!-- 労働保険(労災保険・雇用保険)に関する事務 -->
          {{$t('MODULE.I0002_LBL_TEXT6')}}
        </li>
        <li>
          <!-- 健康保険・厚生年金保険法に関する事務 -->
          {{$t('MODULE.I0002_LBL_TEXT7')}}
        </li>
        <li>
          <!-- 国民健康保険法の第3号被保険者制度に関する事務 -->
          {{$t('MODULE.I0002_LBL_TEXT8')}}
        </li>
      </ul>
    </div>
    <!-- 上記内容に同意します。 -->
    <el-checkbox style="margin-top:10px" v-model="checked">{{$t('MODULE.I0002_LBL_ABOVE_AGREE')}}</el-checkbox>
    <div align="center">
      <!-- 入力画面 -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 10pt;width:20%;padding-left:8px" type="primary" 
        :disabled="!checked" @click="toInputPage()">{{$t('MODULE.I0002_LBL_INPUT_PAGE')}}</el-button>
      <!-- 入力画面 -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 10pt;width:20%;margin-left:10px" type="primary" 
        @click="back">{{$t('MODULE.I0002_LBL_BACK')}}</el-button>
    </div>
  </div>
</template>
<script>
let url = require("@/../config/sysConfig")
export default {
  data() {
    return {
      checked: false
    }
  },
  created() {

  },
  methods: {
    toInputPage() {
      this.$router.push({ path: url.routerUrl_I0009 })
    },// 戻る
    back() {
      this.$router.push({ path: url.routerUrl_I0010 })
    }
  }
}
</script>
<style>
.i0002-title {
  color: rgb(71, 71, 71);
  text-align: center;
  margin-top: 10px;
  height: 40px;
  border-radius: 3px;
  border: 1px solid rgb(165, 165, 165);
  background-image: linear-gradient(#f0f0f0, #e0e0e0);
}
.i0002-main {
  color: rgb(71, 71, 71);
  margin-top: 10px;
  border-radius: 3px;
  border: 1px solid rgb(165, 165, 165);
  font-size: 14px;
}
.i0002 ul {
  padding-inline-start: 20px;
}
.i0002 p {
  margin-top: 10px;
}
.i0002-css-btn {
  margin-top: 15px;
  width: 100px;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0002-css-btn:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0002-css-btn:active,
.i0002-css-btn:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0002.vue